import React from 'react'

import {
    ListContainer,
    ListHeading,
    ListTitle,
    ListingSubtitle,
    ListDivider,
    ListRow,
    SizeInfo,
    ListItemTitle,
    SizeDimension,
    SizePicture,
    SizeGuide,
    InfoList
} from './VehicleInfoList.styles'

function getSize(plateSize:PlateSize){
    const maxSizeWidth = 140;
    const maxPlateWidth = 520;
    
    const plateWidth = plateSize.width * maxSizeWidth / maxPlateWidth;
    const plateHeight = plateSize.height * plateWidth / plateSize.width;

    return {
        width: plateWidth,
        height: plateHeight
    };
}

interface AvailableSizeProps{
    title: string
    availableSizes: PlateSize[]
}

interface PlateSize{
    name:string
    width: number
    height: number
}

const AvailableSizeList = ({title,availableSizes}:AvailableSizeProps) =>{
    return (
    <ListContainer>
        <ListHeading>
            <ListTitle>
                {title}
            </ListTitle>
            <ListingSubtitle>
                Size Guide
            </ListingSubtitle>
        </ListHeading>
        <ListDivider />
        <InfoList>
            {
                availableSizes.map((item,key)=>{
                    return (
                        <ListRow key={key}>
                            <SizeInfo>
                                <ListItemTitle>{item.name}</ListItemTitle>
                                <SizeDimension>{item.width}mm x {item.height}mm</SizeDimension>
                            </SizeInfo>
                            <SizePicture>
                                <SizeGuide size={getSize(item)}/>
                            </SizePicture>
                        </ListRow>
                    );
                })
            }
        </InfoList>
    </ListContainer>

    );
}



export default AvailableSizeList;